module.exports = __webpack_public_path__ + "media/images/react/search/travel-418a5e807e71d68c023e0416d879cbe1.svg";